import { makeStyles, css } from '@conexasaude/conexa-hero'

const useStyles = makeStyles({
  pageContainer: css`
    display: flex;
    flex-direction: column;
    align-items: baseline;

    @media (max-width: 639px) {
      display: flex;
      align-items: flex-start;
      flex-direction: column;
      flex-wrap: wrap;
    }
  `,

  headerChoice: ({ colors }) => css`
    display: flex;
    align-items: center;
    border-style: solid;
    border-bottom-color: ${colors.neutral[100]};
    border-bottom-width: 1px;
    width: 100%;
    min-height: 72px;
    margin-top: -16px;

    @media (max-width: 639px) {
      display: flex;
      width: 100%;
      align-items: center;
    }
  `,

  logoWhiteLabel: ({ spacing }) => css`
    max-width: 120px;
    padding: ${spacing.xxs} 0;
    margin-bottom: ${spacing.xs};

    @media (max-width: 639px) {
      width: 115px;
    }
  `,

  linkSupportChoice: css`
    cursor: pointer;
    text-align: left;
    width: fit-content;

    @media (max-width: 639px) {
      text-align: center;
      width: 100%;
      max-width: 512px;
    }
  `,

  titleChoice: ({ colors, spacing, typography, fontWeights }) => css`
    margin: ${spacing.xs} 0;
    font-family: ${typography.label.fontFamily};
    font-weight: ${fontWeights.extraBold};
    color: ${colors.neutral[400]};
  `,

  subtitleChoice: ({ colors, typography }) => css`
    color: ${colors.neutral[300]};
    font-family: ${typography.label.fontFamily};
  `,

  container: css`
    width: 100%;
    display: flex;
    flex-direction: column;
  `,

  titleLayout: ({ spacing }) => css`
    display: flex;
    flex-direction: column-reverse;
    margin-bottom: ${spacing.sm};

    @media (min-width: 639px) {
      flex-direction: row;
      justify-content: space-between;
    }
  `,

  loadingPageWrapper: ({ spacing }) => css`
    margin-top: ${spacing.xs};
  `,
})

export default useStyles
